export default __webpack_public_path__ + "static/shark_bigdaddy-f6ba8573d120a62621cd35d7ac988426.gif";